import React from "react";
import classes from "./LocationCard.module.css";
import { Pencil, Trash } from "../../constant";

import Popover from "../Popovers";
import { EditIcon, DeleteIcon, ViewDetailIcon } from "../../constant";

const LocationCard = ({ location, onEdit, onDelete, setShow, onView, data }) => {
  // Menu items for the location actions
  const menuItems = [
    // {
    //   label: "View Details",
    //   icon: <ViewDetailIcon />,
    //   command: () => {
    //     if (typeof onView === 'function') {
    //       onView(location);
    //     }
    //   }
    // },
    {
      label: "Edit Location",
      icon: <Pencil className={classes.icon} />,
      command: () => {
        if (typeof onEdit === "function") {
          onEdit(location);

        }
      },
    },
    {
      label: "Delete Location",
      icon: <Trash className={classes.icon} />,
      command: () => {
        if (typeof onDelete === "function") {
          onDelete(location);
        }
      },
    },
  ];

  return (
    <address className={classes.wrapper}>
      <header className={classes.header}>
        <h2 className={classes.country}>{location?.locationName}</h2>
        <span className={classes.actionMenu}>
          <Popover items={menuItems} />
        </span>
      </header>

      <h3 className={classes.city}>{location?.locationCity}</h3>
    </address>
  );
};

// Add default props
LocationCard.defaultProps = {
  location: {},
  onEdit: () => { },
  onDelete: () => { },
  onView: () => { },
};

export default LocationCard;
